import styled from "styled-components";

export const LeaveReviewComponentMainDiv = styled.main``;

export const LeaveReviewComponentHeroMainDiv = styled.section`
  > div {
    display: flex;
    gap: 10px;
    width: 100%;
    padding: 210px 40px 100px;
    align-items: center;
    justify-content: center;
  }
  .leavereview-container {
    display: flex;
    flex-flow: column;
    gap: 60px;
    align-items: center;
    justify-content: center;
    width: 100%;
    flex: 1;
    max-width: 1140px;
  }
  .leavereview-header-container {
    display: flex;
    flex-flow: column;
    gap: 24px;
    width: 100%;
    flex: 1;
    align-items: center;
    justify: center;

    max-width: 810px;
  }
  .leavereview-header-wrapper {
    display: flex;
    flex-flow: column;
    gap: 12px;
    width: 100%;

    flex: 1;
    align-items: center;
    justify: center;
  }
  .leavereview-header-text-wrapper {
    text-align: center;

    > h1 {
      font-size: 76px;
    }
    > p {
      font-size: 20px;
      font-weight: 400;
    }
  }
  .leavereview-form-container {
    width: 100%;
    flex: 1;
    background: #060606;
    border-radius: 16px;
    padding: 32px;
    display: flex;
    gap: 24px;
    align-items: stretch;
  }
  .leavereview-form-wrapper {
    width: 100%;
    flex: 1;
    display: flex;
    gap: 36px;
    border-radius: 16px;
    flex-flow: column;
  }
  .leavereview-form-input-container {
    width: 100%;
    flex: 1;
    display: flex;
    gap: 20px;
    flex-flow: column;
    border-bottom: 1px solid #f5f5f5;
    height: 46px;
    padding: 0 0 20px 0;
    transition: all 0.4s;
    &:focus-within {
      border-bottom: 1px solid #da4e24;
    }
  }
  .leavereview-form-input-wrapper {
    width: 100%;
    flex: 1;
    height: 100%;
    font-size: 20px;
    background: transparent;
    border: none;
    outline: none;
    color: white;
    &::placeholder {
      color: #888;
      text-transform: capitalize;
      font-size: 20px;
    }
  }
  .leavereview-form-text-area-wrapper {
    font-family: inter;
    resize: none;
    &::-webkit-scrollbar {
      display: none;
    }

    scrollbar-width: none;

    &::placeholder {
      color: #888;
      text-transform: capitalize;
      font-size: 20px;
      font-family: inter;
    }
  }

  .leavereview-form-left {
    display: flex;
    flex-flow: column;
    gap: 32px;
  }
  .leavereview-form-bottom {
    display: flex;
    flex-flow: column;
    gap: 10px;
  }
  .leavereview-form-bottom-text-wrapper {
    > {
      font-size: 16px;
    }

    a {
      color: #da4e24;
    }
  }
`;
export const LeaveReviewComponentContactDiv = styled.div`
  display: flex;
  flex-flow: column;
  gap: 24px;
  width: 45%;
  justify-content: space-between;
  flex: 1;

  .leavereview-info-header-text-container {
    display: flex;
    gap: 10px;
    flex-flow: column;
  }
  .leavereview-info-header-text-wrapper {
    > p {
      font-size: 18px;
      font-family: inter;
    }
    > p,
    > h3 {
      color: inherit;
      transition: all 0.3s;
      > a {
        color: inherit;
        font-size: inherit;
      }
    }
    > h3 {
      font-size: 3em;
    }
    &:hover {
      color: #da4e24;
    }
  }
  .leavereview-address-info-container {
    display: flex;
    flex-flow: column;
    gap: 46px;
    width: 100%;
  }
  .leavereview-address-info-wrapper {
    display: flex;
    flex-flow: column;
    gap: 8px;
    width: 100%;
  }
  .leavereview-address-info-text-wrapper {
    > p {
      font-size: 16px;
    }
  }
  .leavereview-address-info-address-text-wrapper {
    opacity: 0.4;
  }
  .leavereview-link-wrapper {
    display: flex;
    gap: 10px;
    align-items: center;
    cursor: pointer;
    transition: all 0.5s;
    &:hover {
      opacity: 0.9;
      .leavereview-icon-wrapper {
        > svg {
          transform: rotate(180deg);
        }
      }
      .leavereview-link-text-wrapper {
        transform: translateY(-27px);

        > p {
        }
      }
    }
  }
  .leavereview-address-link-container {
    display: flex;
    flex-flow: column;
    gap: 8px;
  }
  .leavereview-icon-wrapper {
    width: 20px;
    height: 20px;

    color: #da4e24;
    > svg {
      transition: all 0.5s;

      transform: rotate(135deg);
      fill: #da4e24;
      width: 20px;
      height: 20px;

      color: #da4e24;
    }
  }
  .leavereview-link-text-wrapper {
    transition: all 0.3s;

    > p {
      font-size: 18px;
      font-weight: 500;
    }
  }
  .leavereview-link-text-container {
    display: flex;
    flex-flow: column;
    gap: 4px;
    height: 24px;
    overflow: hidden;
  }
  .leavereview-address-info-item-container {
    display: flex;
    flex-flow: column;
    gap: 8px;
  }
`;

export const leavereviewComponentTrustedDiv = styled.section`
  > div {
    display: flex;
    gap: 10px;
    width: 100%;
    padding: 100px 40px;
    align-items: center;
    justify-content: center;
  }
  .leavereview-trusted-container {
    display: flex;
    flex-flow: column;
    gap: 32px;
    align-items: center;
    justify-content: center;
    width: 100%;
    flex: 1;
    max-width: 1140px;
  }
  .leavereview-trusted-wrapper {
    width: 100%;
    flex: 1;
  }
  .leavereview-trusted-item-container {
    width: 150px;
    min-width: 150px;
    height: 60px;
    display: flex;
    align-items:center;
    gap:10px;
  }
  .leavereview-trusted-icon-wrapper {
    width: 32px;
    height: 32px;

    color: #da4e24;
    > svg {
      transition: all 0.5s;

      transform: rotate(135deg);
      fill: #da4e24;
      width: 32px;
      height: 32px;

      color: #da4e24;
    }
  }
`;
